import _ from 'lodash';

const nodeTemplatesFromActions = actions =>
  _.compact(
    actions.map(curr => {
      if (!curr) return null;

      const { id, serviceId, typeOf } = curr;

      return {
        action: id,
        selected_api: serviceId,
        type_of: typeOf,
      };
    })
  );

export default nodeTemplatesFromActions;
